export function findFieldByType(fields = [], type) {
  return fields.find(field => field.type === type);
}
